import { FunctionComponent, ReactNode, useState } from 'react'

export interface ShowMoreTextButtonProps {
  toggle: () => void
  show: boolean
}

export interface ShowMoreTextProps {
  children: ReactNode
  ButtonComponent: FunctionComponent<ShowMoreTextButtonProps>
  lines: number
  disabled?: boolean
}

export function ShowMoreText(props: ShowMoreTextProps) {
  const { children, lines, ButtonComponent, disabled } = props
  const [show, setShow] = useState(false)
  if (disabled) return <>{children}</>
  return (
    <>
      <div
        style={
          show
            ? {
                overflowY: 'initial',
              }
            : {
                overflowY: 'hidden',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: lines,
              }
        }
      >
        {children}
      </div>
      <ButtonComponent toggle={() => setShow(!show)} show={show} />
    </>
  )
}
